import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    update_namespace_preference,
    update_namespace_preferences,
    fetch_namespace_preferences,
} from "../../actions/DMP/dispatchers";
import logger from "../../utils/logger/library";

export function useLocalPreferences(namespace) {
    const preferences = useSelector(
        (state) => state.dmp.preferences[namespace]
    );
    const dispatch = useDispatch();
    return {
        preferences,
        update: (...args) => {
            if (args.length === 1) {
                const [preferences] = args;
                dispatch(update_namespace_preferences(namespace, preferences));
                return;
            } else if (args.length === 2) {
                const [key, value] = args;
                dispatch(
                    update_namespace_preference(namespace, key, value, false)
                );
                return;
            } else {
                logger.error(
                    `(useLocalPreferences) Expected preferences or key, value got: ${args}`
                );
            }
        },
    };
}

export function useLocalPreferencesLoaded(namespace) {
    return useSelector(
        (state) => !!Object.keys(state.dmp.preferences[namespace] || {}).length
    );
}

export function useLocalPreferencesLoader(namespace, keys) {
    const preferences = useSelector(
        (state) => state.dmp.preferences[namespace]
    );
    const dispatch = useDispatch();

    useEffect(() => {
        if (preferences) {
            return;
        }

        dispatch(fetch_namespace_preferences(namespace, keys));
    }, [preferences, namespace, keys]);
}
